import BaseField from "./BaseField";

export class DropdownField extends BaseField{

    constructor(props) {
        super(props);
    }

    renderValues(){
        return this.props.Values.map((value, index) => {
            return <option key={index} value={value.key}>{value.value}</option>
        })
    }

    render(){
        if(this.props.Values === undefined){
            return false;
        }
        return(
            <div className={this.props.Columns}>
                <div className="field dropdown">
                    <label className="" htmlFor={this.props.id}>
                        {this.renderLabelText()}
                    </label>
                    <select id={this.props.id} className="form-control" name="dropdown" onChange={(e) => {this.props.collectData(this.props.id, e.target.options[e.target.selectedIndex].text)}}>                        {this.renderValues()}
                    </select>
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}
export default DropdownField;